// Settings index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    adminSettings: {
      items: [],
      count: '',
      entity: {}
    },
    senders: {
      items: [],
      count: '',
      entity: {},
    },
    payers: {
      items: [],
      count: '',
      entity: {},
    },
    payerCarriers: {
      items: [],
      count: '',
      entity: {},
    },
    printers: {
      items: [],
      count: '',
      entity: {},
    },
    packages: {
      items: [],
      count: '',
      entity: {},
    },
    users: {
      items: [],
      count: '',
      entity: {},
    },
    wall_news: {
      items: [],
      count: '',
      entity: {},
    },
    smtps: {
      items: [],
      count: '',
      entity: {},
    },
    allSmtps: [],
    systems: {
      items: [],
      count: '',
      entity: {},
    },
    user: {},
    userPermissions: [],
    templates: {
      items: [],
      count: '',
      entity: [],
    },
    ftpSettings: {
      items: [],
      count: '',
      entity: [],
    },
    notification: {},
    notifications: {
      items: [],
      count: '',
      entity: {},
    },
    automation: {
      items: null,
      entity: {}
    },
    automations: {
      items: [],
      count: '',
      entity: {},
    },
    automationActions: {
      items: [],
      count: '',
      entity: {},
    },
    uploadProgress: 0,
    label_printers: [],
    document_printers: [],
    label_formats: [],
    shippers: [],
    goods_types: [],
    return_waybill_action_types: [],
    document_packages_available: [],
    parcel_packages_available: [],
    pallet_packages_available: [],
    load_packages_available: [],
    currencies: [],
    carrierAccounts: {
      items: [],
      count: '',
      entity: {},
    },
    carrierAccount: {},
    shippingAgents: [],
    companyAvailableShippingAgents: [],
    companyAvailableShippingProducts: [],
    integrationsByCarrier: [],
    integrationParams: {
      login: [],
      barcode: [],
    },
    carrierAccountProducts: [],
    carrierAccountProduct: [],
    accountConsignor: [],
    accountDanskeCode: {},
    accountDanskeCodes: {
      items: [],
      entity: {}
    },
    allPackagingOptions: {}
  },
  actions,
  mutations,
  getters,
};
